import { Component } from "react";

// ══════════════════════════════════════════════════════════════
// FORGE ERROR BOUNDARY — Catches render crashes gracefully
// Shows recovery UI instead of blank white screen
// ══════════════════════════════════════════════════════════════

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[Forge] Render error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: "100vh",
          background: "#010102",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 32,
          textAlign: "center",
          fontFamily: "'Rajdhani', sans-serif",
        }}>
          <div style={{
            width: 60, height: 60, borderRadius: 14,
            border: "1.5px solid rgba(180,195,210,0.2)",
            background: "linear-gradient(145deg, rgba(180,195,210,0.06), rgba(180,195,210,0.02))",
            display: "flex", alignItems: "center", justifyContent: "center",
            marginBottom: 24,
          }}>
            <span style={{ fontSize: 'var(--fs-title)', fontFamily: "serif", fontWeight: 800, color: "rgba(180,195,210,0.6)" }}>Fe</span>
          </div>
          <div style={{
            fontSize: 'var(--fs-h3)', fontWeight: 700, color: "#E8EAED",
            fontFamily: "'Cinzel', serif", letterSpacing: ".08em",
            marginBottom: 8,
          }}>
            SOMETHING WENT WRONG
          </div>
          <div style={{
            fontSize: 'var(--fs-base)', color: "rgba(180,195,210,0.5)",
            fontFamily: "'IBM Plex Mono', monospace",
            lineHeight: 1.8, marginBottom: 32, maxWidth: 300,
          }}>
            Forge encountered an unexpected error. Your data is safe — it's stored locally on your device.
          </div>
          {import.meta.env.DEV && this.state.error && (
            <div style={{
              marginBottom: 24, padding: 16, maxWidth: 400,
              background: "rgba(255,100,100,0.08)",
              border: "1px solid rgba(255,100,100,0.2)",
              borderRadius: 8, textAlign: "left", overflowX: "auto",
            }}>
              <div style={{ fontSize: 'var(--fs-xs)', color: "rgba(180,195,210,0.4)", fontFamily: "'IBM Plex Mono', monospace", marginBottom: 4 }}>
                Error details (dev only):
              </div>
              <pre style={{ fontSize: 'var(--fs-xs)', color: "#ff6b6b", fontFamily: "'IBM Plex Mono', monospace", whiteSpace: "pre-wrap", margin: 0 }}>
                {this.state.error.toString()}
              </pre>
            </div>
          )}
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              window.location.reload();
            }}
            style={{
              padding: "14px 32px",
              background: "linear-gradient(135deg, rgba(94,234,212,0.15), rgba(94,234,212,0.05))",
              border: "1.5px solid rgba(94,234,212,0.3)",
              borderRadius: 8,
              color: "#5EEAD4",
              fontSize: 'var(--fs-body)',
              fontWeight: 700,
              fontFamily: "'IBM Plex Mono', monospace",
              letterSpacing: ".14em",
              cursor: "pointer",
            }}
          >
            RELOAD FORGE
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
